import React, {useState} from 'react';
import CustomButton from "../customBtn/CustomButton";
import './searchBox.css'
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";


function SearchBox(props) {
    const [inputValue, setInputValue] = useState("")
    const navigate = useNavigate();

    const searchButtonClicked = () => {
        if (inputValue.trim().length > 3) {
            navigate(`/blogs/search/?search=${inputValue}`)
        } else {
            toast.warn('برای جست‌وجو باید بیش از سه کارکتر وارد نمایید')
        }
    }
    return (
        <>
            <div className="in-content-search-box">
                <input type="text" placeholder={'جست و جو ...'}
                       onChange={e => setInputValue(e.target.value)}
                       onKeyDown={e => {
                           if (e.key === 'Enter') {
                               searchButtonClicked();
                           }
                       }}/>
                <CustomButton buttonClicked={searchButtonClicked} height={'100%'}
                              icon={<i className="fa-solid fa-magnifying-glass"></i>}
                              text={' '}/>
            </div>

        </>
    );
}

export default SearchBox;